import api from './api';

class DocumentosService {
    /**
     * Baixar Guia de Encaminhamento
     * @param codigo - Código codificado em base64 (pedidoId_colaboradorId)
     */
    async downloadGuia(codigo: string): Promise<Blob> {
        const response = await api.get(`/documentos/guia/${codigo}`, {
            responseType: 'blob',
        });
        return response.data;
    }

    /**
     * Baixar ASO (Atestado de Saúde Ocupacional)
     * @param codigo - Código codificado em base64 (pedidoId_colaboradorId)
     */
    async downloadASO(codigo: string): Promise<Blob> {
        const response = await api.get(`/documentos/aso/${codigo}`, {
            responseType: 'blob',
        });
        return response.data;
    }

    /**
     * Baixar Ficha Médica
     * @param codigo - Código codificado em base64 (pedidoId_colaboradorId)
     */
    async downloadFichaMedica(codigo: string): Promise<Blob> {
        const response = await api.get(`/documentos/ficha-medica/${codigo}`, {
            responseType: 'blob',
        });
        return response.data;
    }
    /**
     * Baixar Kit Exame (Guia+Ficha+ASO)
     * @param codigo - Código codificado em base64 (pedidoId_colaboradorId)
     */
    async downloadKitExame(codigo: string): Promise<Blob> {
        const response = await api.get(`/documentos/kit-exame/${codigo}`, {
            responseType: 'blob',
        });
        return response.data;
    }
}

export const documentosService = new DocumentosService();
